/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createCreateApiAccessResponseFromDiscriminatorValue, createErrorResponseFromDiscriminatorValue, createGetApiAccessResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type CreateApiAccessResponse, type ErrorResponse, type GetApiAccessResponse, type InternalErrorResponse } from '../../../models/index.js';
// @ts-ignore
import { ListRequestBuilderRequestsMetadata, type ListRequestBuilder } from './list/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/organization/api-access
 */
export interface ApiAccessRequestBuilder extends BaseRequestBuilder<ApiAccessRequestBuilder> {
    /**
     * The list property
     */
    get list(): ListRequestBuilder;
    /**
     * Get Api Access for Organization by organization ID and access scope
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetApiAccessResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<ApiAccessRequestBuilderGetQueryParameters> | undefined) : Promise<GetApiAccessResponse | undefined>;
    /**
     * Creates API access credentials for the organization. The credentials are always issued with the admin scope — the scope is not selectable. Use the website API key endpoint for storefront credentials. The key value is returned once and cannot be retrieved again.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<CreateApiAccessResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 401 status code
     * @throws {ErrorResponse} error when the service returns a 403 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     post(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<CreateApiAccessResponse | undefined>;
    /**
     * Get Api Access for Organization by organization ID and access scope
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<ApiAccessRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
    /**
     * Creates API access credentials for the organization. The credentials are always issued with the admin scope — the scope is not selectable. Use the website API key endpoint for storefront credentials. The key value is returned once and cannot be retrieved again.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Get Api Access for Organization by organization ID and access scope
 */
export interface ApiAccessRequestBuilderGetQueryParameters {
    accessScope?: string;
}
/**
 * Uri template for the request builder.
 */
export const ApiAccessRequestBuilderUriTemplate = "{+baseurl}/api/organization/api-access?accessScope={accessScope}";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const ApiAccessRequestBuilderNavigationMetadata: Record<Exclude<keyof ApiAccessRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    list: {
        requestsMetadata: ListRequestBuilderRequestsMetadata,
    },
};
/**
 * Metadata for all the requests in the request builder.
 */
export const ApiAccessRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: ApiAccessRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetApiAccessResponseFromDiscriminatorValue,
    },
    post: {
        uriTemplate: ApiAccessRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            401: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            403: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createCreateApiAccessResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
